import { render, staticRenderFns } from "./DateField.vue?vue&type=template&id=4685bd3a&scoped=true"
import script from "./DateField.vue?vue&type=script&lang=js"
export * from "./DateField.vue?vue&type=script&lang=js"
import style0 from "./DateField.vue?vue&type=style&index=0&id=4685bd3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4685bd3a",
  null
  
)

export default component.exports